/**
 * Register page — directs new users to rule42-auth registration.
 *
 * Registration is handled entirely by rule42-auth's user UI.
 * This page provides context and a CTA that deep-links to the
 * auth service registration endpoint.
 *
 * @module apps/web/pages/Register
 * @since W2.9
 */

import { AuthLayout } from '../components/AuthLayout.js';

const AUTH_ISSUER = import.meta.env.VITE_AUTH_ISSUER ?? 'https://auth.rule42.ai';

export function RegisterPage() {
  const registerUrl = `${AUTH_ISSUER}/register`;

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Join rule42 to access methodology tools and AI-assisted development."
    >
      <div className="space-y-4">
        <div className="space-y-3 text-sm text-slate-400">
          <p>Your rule42 account gives you access to:</p>
          <ul className="space-y-1.5 ml-4">
            {[
              'AI-assisted methodology management',
              'Protected content delivery',
              'Workspace sync across devices',
              'Org-level governance controls',
            ].map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="mt-0.5 w-1.5 h-1.5 rounded-full bg-brand-indigo shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <a
          href={registerUrl}
          className="btn-primary w-full text-center"
        >
          Create account at rule42
        </a>

        <p className="text-center text-sm text-slate-400">
          Already have an account?{' '}
          <a
            href="/login"
            className="text-indigo-400 hover:text-indigo-300 transition-colors"
          >
            Sign in
          </a>
        </p>
      </div>
    </AuthLayout>
  );
}
